import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import { getMinutes, getHours, getDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import _isNumber from 'lodash/isNumber';
import { HourOfOperationPropType } from '../../services/proptypes';
var CartHOC = /*#__PURE__*/function (_React$Component) {
  _inherits(CartHOC, _React$Component);
  var _super = _createSuper(CartHOC);
  function CartHOC(props) {
    var _this;
    _classCallCheck(this, CartHOC);
    _this = _super.call(this, props);
    _this.state = {
      items: []
    };
    _this.addItem = _this.addItem.bind(_assertThisInitialized(_this));
    _this.removeItem = _this.removeItem.bind(_assertThisInitialized(_this));
    _this.updateItem = _this.updateItem.bind(_assertThisInitialized(_this));
    _this.containsItem = _this.containsItem.bind(_assertThisInitialized(_this));
    _this.clearCart = _this.clearCart.bind(_assertThisInitialized(_this));
    _this.getItemIndex = _this.getItemIndex.bind(_assertThisInitialized(_this));
    _this.isOpen = _this.isOpen.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CartHOC, [{
    key: "getItemIndex",
    value: function getItemIndex(item) {
      var lookupFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
        return key;
      };
      var items = this.state.items;
      return items.map(function (aItem) {
        return lookupFunc(aItem);
      }).indexOf(lookupFunc(item));
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      this.setState(function (_ref) {
        var items = _ref.items;
        return {
          items: [].concat(_toConsumableArray(items), [item])
        };
      });
    }
  }, {
    key: "removeItem",
    value: function removeItem(index) {
      this.setState(function (_ref2) {
        var items = _ref2.items;
        return {
          items: [].concat(_toConsumableArray(items.slice(0, index)), _toConsumableArray(items.slice(index + 1, items.length)))
        };
      });
    }
  }, {
    key: "updateItem",
    value: function updateItem(item, index) {
      this.setState(function (_ref3) {
        var items = _ref3.items;
        return {
          items: [].concat(_toConsumableArray(items.slice(0, index)), [item], _toConsumableArray(items.slice(index + 1, items.length)))
        };
      });
    }
  }, {
    key: "containsItem",
    value: function containsItem(item) {
      var comparisionFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
        return key;
      };
      var items = this.state.items;
      return items.map(function (aItem) {
        return comparisionFunc(aItem);
      }).includes(comparisionFunc(item));
    }
  }, {
    key: "clearCart",
    value: function clearCart() {
      this.setState({
        items: []
      });
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      var _this$props = this.props,
        hours = _this$props.hours,
        timezone = _this$props.timezone;

      // Backend stores weeks starting on Monday, but
      // date-fns starts on Sunday.
      var translateDay = {
        7: 0,
        // Sunday -> Monday
        1: 1,
        // Monday -> Tuesday
        2: 2,
        // Tuesday -> Wednesday
        3: 3,
        // Wednesday -> Thursday
        4: 4,
        // Thursday -> Friday
        5: 5,
        // Friday -> Saturday
        6: 6 // Saturday -> Sunday
      };

      // Find the relevant day...
      var today = getDay(utcToZonedTime(new Date(), timezone));
      var todaysHours = hours.filter(function (i) {
        return translateDay[i.day] === today;
      })[0];
      var thisHour = getHours(utcToZonedTime(new Date(), timezone));
      var thisMinute = getMinutes(utcToZonedTime(new Date(), timezone));

      // Convert open and closed hours
      var convertTime = function convertTime(timeToConvert) {
        if (!_isNumber(timeToConvert)) return [];
        var formattedTime = CartHOC.normalizeHour(timeToConvert);
        var hour = formattedTime.substring(0, 2);
        var minute = formattedTime.substring(2, 4);
        if (hour === '24') {
          return [parseInt('00', 10), parseInt(minute, 10)];
        }
        return [parseInt(hour, 10), parseInt(minute, 10)];
      };
      var compareTimes = function compareTimes(open, close) {
        if (!open || !close) return false;
        var afterOpen = function afterOpen() {
          if (thisHour > open[0]) return true;
          if (thisHour === open[0]) return thisMinute >= open[1];
          return false;
        };
        var beforeClose = function beforeClose() {
          if (thisHour < close[0]) return true;
          if (thisHour === close[0]) return thisMinute <= close[1];
          return false;
        };
        return afterOpen() && beforeClose();
      };
      if (todaysHours) {
        var todayOpen = todaysHours.open;
        var todayClose = todaysHours.close;
        if (_isNumber(todayOpen) && _isNumber(todayClose)) {
          var convertedOpen = convertTime(todayOpen);
          var convertedClose = convertTime(todayClose);
          return compareTimes(convertedOpen, convertedClose);
        }
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var items = this.state.items;
      return children({
        items: items,
        isOpen: this.isOpen(),
        addItem: this.addItem,
        removeItem: this.removeItem,
        updateItem: this.updateItem,
        containsItem: this.containsItem,
        clearCart: this.clearCart,
        getItemIndex: this.getItemIndex
      });
    }
  }], [{
    key: "normalizeHour",
    value: function normalizeHour(hour) {
      var hourAsString = hour.toString();
      if (!hourAsString) return null;
      return hourAsString.padStart(4, '0');
    }
  }]);
  return CartHOC;
}(React.Component);
export { CartHOC as default };
CartHOC.propTypes = {
  children: PropTypes.func,
  hours: PropTypes.arrayOf(HourOfOperationPropType),
  timezone: PropTypes.string
};
CartHOC.defaultProps = {
  children: function children() {
    return null;
  },
  hours: [],
  timezone: 'America/New_York'
};